import { useConnection, useWallet } from '@solana/wallet-adapter-react'
import { LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js'
import Image from "next/legacy/image"
import { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Form, InputGroup, Row, Table } from 'react-bootstrap'
import { connect, useSelector } from 'react-redux'
//@ts-ignore
import hdgCoin from '../../assets/coins/hdg-white.svg'
import { SignSendConfirmTransaction } from '../../lib/SignSendConfirmTransaction'
import TransactionStep from '../../lib/TransactionStep'
import { numberWithCommas } from '../../lib/Utils'
import { handleConnectionError } from '../../lib/utils/handleConnectionError'
import { StakingPool } from '../../on-chain/accounts/StakingPool'
import { StakingPoolPosition } from '../../on-chain/accounts/StakingPoolPosition'
import { default as LoadHedgeStakingPoolPosition, default as LoadHedgeStakingPoolPositions } from '../../on-chain/loaders/LoadHedgeStakingPoolPositions'
import LoadHedgeStakingPoolState from '../../on-chain/loaders/LoadHedgeStakingPoolState'
import {
  getClaimHedgeStakingPoolPositionTransactionStep,
  getCloseHedgeStakingPoolPositionTransactionStep,
  getDepositHedgeStakingPoolTransactionStep
} from '../../on-chain/transactions/HedgeStakingPoolTransactions'
import { HedgeProgram } from '../../on-chain/utils/HedgeConstants'
import { RootState } from '../../pages/_app'
import { setLoadingScreenMessage } from '../../reducers/loadingScreenReducer'
import { refreshWallet } from '../../reducers/walletReducer'
import Balance from '../Balance'
import InfoHover from '../InfoHover'
import { Collateral } from "../../on-chain/utils/OracleAccounts";
import DropdownBalance, { TokenBalance } from "../DropdownBalance";

function HedgeStakingPool({ dispatch, userHedgeBalance, vaultTypes, networkConnection }) {
  const [totalPoolUsh, setTotalPoolUsh] = useState(0)

  const [modalShowing, setModalShowing] = useState<boolean>()
  const [depositInput, setDepositInput] = useState<string>('')
  const [openPoolPositions, setOpenPoolPositions] = useState<StakingPoolPosition[]>([])
  const [closedPoolPositions, setClosedPoolPositions] = useState<StakingPoolPosition[]>([])
  const [poolState, setPoolState] = useState<StakingPool>()
  const [isLoadingPositions, setIsLoadingPositions] = useState(true)
  const [totalPoolDeposits, setTotalPoolDeposits] = useState<number>(0)
  const [userTotalDeposited, setUserTotalDeposited] = useState<number>(0)
  const [userFeesCollected, setUserFeesCollected] = useState<number>(0)
  const [poolAprStakingPosition, setPoolAprStakingPosition] = useState<StakingPoolPosition[]>([])
  const [lastTransactionSignature, setLastTransactionSignature] = useState()
  const [processingTransaction, setProcessingTransaction] = useState(false)
  const mountedRef = useRef(false)
  const recentPrices = useSelector(
    (state: RootState) => state.wallet.recentPrices
  ) as Immutable.Map<string, number>
  const hdgPrice = useSelector((state: RootState) => state.wallet.hdgPrice)
  const ushPrice = useSelector((state: RootState) => state.wallet.ushPrice)

  const { connection } = useConnection()
  const { publicKey: userWalletPublicKey } = useWallet()
  const Wallet = useWallet()

  useEffect(() => {
    refreshPoolPositions()
    refreshPoolState()
  }, [userWalletPublicKey, networkConnection, lastTransactionSignature])

  // effect just for tracking mounted state
  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    initPoolAprStakingPosition()
  }, [])

  const refreshPoolPositions = async () => {
    const program = HedgeProgram(connection, Wallet)
    // setIsLoadingPositions(true)

    console.log('Staking Pool refreshPoolPositions')
    LoadHedgeStakingPoolPositions(program, userWalletPublicKey)
      .then((positions) => {
        console.log('Loading Staking Pool Positions', positions)
        setOpenPoolPositions(
          positions.filter((position) => {
            return position.isOpen()
          })
        )
        setClosedPoolPositions(
          positions.filter((position) => {
            return !position.isOpen()
          })
        )
      })
      .then(() => {
        setIsLoadingPositions(false)
      })
      .catch(handleConnectionError)
  }
  const refreshPoolState = async () => {
    const program = HedgeProgram(connection, Wallet)
    LoadHedgeStakingPoolState(program).then(setPoolState).catch(handleConnectionError)
  }

  const initPoolAprStakingPosition = async () => {
    const program = HedgeProgram(connection, Wallet)

    LoadHedgeStakingPoolPosition(program, new PublicKey('7Q1YTwHAoXnB86MQzZ11BS3kqXVMBAgrBPFEioKJRRQU'))
      .then((positions) => {
        positions.filter((position) => {
          return position.isOpen()
        })
        setPoolAprStakingPosition(positions)
      })
      .catch(handleConnectionError)
  }

  const getParsedDepositInput = () => {
    const val = parseFloat(depositInput)
    if (val) {
      return val * LAMPORTS_PER_SOL
    }
  }

  const handleDeposit = async () => {
    let depositAmount = getParsedDepositInput()
    if (!depositAmount) {
      return
    }
    dispatch(setLoadingScreenMessage('Building Transaction'))
    const program = HedgeProgram(connection, Wallet)
    const steps: TransactionStep[] = []

    if (openPoolPositions.length > 0) {
      depositAmount += openPoolPositions[0].deposited
      steps.push(
        await getCloseHedgeStakingPoolPositionTransactionStep(
          program,
          userWalletPublicKey,
          openPoolPositions[0]
        )
      )
      steps.push(
        await getClaimHedgeStakingPoolPositionTransactionStep(
          program,
          userWalletPublicKey,
          openPoolPositions[0]
        )
      )
    }

    steps.push(
      await getDepositHedgeStakingPoolTransactionStep(program, userWalletPublicKey, depositAmount)
    )

    setProcessingTransaction(true)
    SignSendConfirmTransaction(connection, Wallet, steps, dispatch, 'Deposit Staking Pool')
      .then((resultSignature) => {
        console.log('Signature Result', resultSignature)
        dispatch(refreshWallet(connection, userWalletPublicKey))
        if (mountedRef.current) {
          refreshPoolState()
          refreshPoolPositions()
          setDepositInput('')
          setProcessingTransaction(false)
        }
      })
      .catch((error) => {
        if (mountedRef.current) {
          setProcessingTransaction(false)
        }
      })
  }

  const handleReclaim = async (position: StakingPoolPosition) => {
    dispatch(setLoadingScreenMessage('Building Transaction'))
    const program = HedgeProgram(connection, Wallet)
    const steps: TransactionStep[] = []

    steps.push(
      await getClaimHedgeStakingPoolPositionTransactionStep(program, userWalletPublicKey, position)
    )

    setProcessingTransaction(true)
    SignSendConfirmTransaction(
      connection,
      Wallet,
      steps,
      dispatch,
      'Cleanup Staking Pool Transaction'
    )
      .then((resultSignature) => {
        console.log('Signature Result', resultSignature)
        dispatch(refreshWallet(connection, userWalletPublicKey))
        if (mountedRef.current) {
          refreshPoolState()
          refreshPoolPositions()
          setDepositInput('')
          setProcessingTransaction(false)
        }
      })
      .catch((error) => {
        if (mountedRef.current) {
          setProcessingTransaction(false)
        }
      })
  }

  const handleClaimOnly = async () => {
    const program = HedgeProgram(connection, Wallet)
    const steps: TransactionStep[] = []

    const redepositAmount = openPoolPositions[0].deposited
    steps.push(
      await getCloseHedgeStakingPoolPositionTransactionStep(
        program,
        userWalletPublicKey,
        openPoolPositions[0]
      )
    )
    steps.push(
      await getClaimHedgeStakingPoolPositionTransactionStep(
        program,
        userWalletPublicKey,
        openPoolPositions[0]
      )
    )

    steps.push(
      await getDepositHedgeStakingPoolTransactionStep(program, userWalletPublicKey, redepositAmount)
    )

    setProcessingTransaction(true)
    SignSendConfirmTransaction(connection, Wallet, steps, dispatch, 'Claim Staking Pool Position')
      .then((resultSignature) => {
        console.log('Signature Result', resultSignature)
        dispatch(refreshWallet(connection, userWalletPublicKey))
        if (mountedRef.current) {
          refreshPoolState()
          refreshPoolPositions()
          setDepositInput('')
          setProcessingTransaction(false)
        }
      })
      .catch((error) => {
        if (mountedRef.current) {
          setProcessingTransaction(false)
        }
      })
  }

  const handleWithdraw = async () => {
    const program = HedgeProgram(connection, Wallet)
    const steps: TransactionStep[] = []

    const redepositAmount = openPoolPositions[0].getUshAvailable().toNumber()
    steps.push(
      await getCloseHedgeStakingPoolPositionTransactionStep(
        program,
        userWalletPublicKey,
        openPoolPositions[0]
      )
    )
    steps.push(
      await getClaimHedgeStakingPoolPositionTransactionStep(
        program,
        userWalletPublicKey,
        openPoolPositions[0]
      )
    )

    setProcessingTransaction(true)
    SignSendConfirmTransaction(
      connection,
      Wallet,
      steps,
      dispatch,
      'Claim and Close Staking Pool Transaction'
    )
      .then((resultSignature) => {
        console.log('Signature Result', resultSignature)
        dispatch(refreshWallet(connection, userWalletPublicKey))
        if (mountedRef.current) {
          refreshPoolState()
          refreshPoolPositions()
          setDepositInput('')
          setProcessingTransaction(false)
        }
      })
      .catch((error) => {
        if (mountedRef.current) {
          setProcessingTransaction(false)
        }
      })
  }

  const renderOpenPosition = () => {
    if (openPoolPositions.length === 0) {
      return <div className="p-4 mb-4 text-muted small text-center">NO OPEN POOL POSITION</div>
    }

    let totalUsh = 0
    let totalSol = 0
    let totalHedge = 0
    let otherTokens: Map<Collateral, TokenBalance> = new Map<Collateral, TokenBalance>();
    openPoolPositions.forEach((position, _index) => {
      totalHedge += position.deposited / LAMPORTS_PER_SOL
      totalUsh += position.getUshAvailable().div(LAMPORTS_PER_SOL).toNumber()

      vaultTypes.forEach((vaultType) => {
        if (vaultType.collateral == Collateral.SOL) {
          totalSol += position.getRewardsAtIndex(vaultType.collateralIndex).div(vaultType.lamportsPerCollateralUnit).toNumber()
        } else {
          let amount = position.getRewardsAtIndex(vaultType.collateralIndex).div(vaultType.lamportsPerCollateralUnit).toNumber()
          let usdPrice = recentPrices.get(vaultType.collateral)

          if (otherTokens.has(vaultType.collateral)) {
            otherTokens.get(vaultType.collateral).amount += amount
          } else {
            otherTokens.set(vaultType.collateral, {amount, usdPrice})
          }
        }
      })
    })

    return (
      <div className="" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
        <Row className="p-4 pb-3 ">
          <Col>
            <div className="flex-fill mb-4 text-end">
              <div className="mb-1 text-muted small">YOUR POOL POSITION</div>
              <div className="mb-2">
                <Balance
                    collateral="HDG"
                    amount={totalHedge}
                    decimals={6}
                    tooltip={`Your deposited HDG tokens. This number will never go down and you can always withdraw.`}
                />
              </div>
              <div className="mb-2">
                <Balance
                    collateral="USH"
                    amount={totalUsh}
                    decimals={4}
                    tooltip={`Your position will collect protocol fees in proportion to the percentage of HDG tokens staked.`}
                />
              </div>
              <div className="mb-2">
                <Balance
                    collateral="SOL"
                    amount={totalSol}
                    decimals={4}
                    tooltip={`Your position will collect a percentage of the liquidated vaults.`}
                />
              </div>
              <div className="mb-3">
                <DropdownBalance tokenToBalance={otherTokens}/>
              </div>
              <Button
                className="me-2"
                variant="outline-light"
                onClick={handleWithdraw}
                size="sm"
                disabled={processingTransaction}
              >
                Close {'&'} Claim Position
              </Button>
              <Button
                variant="outline-light"
                onClick={handleClaimOnly}
                size="sm"
                disabled={processingTransaction}
              >
                Claim Position
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  const handleClickMaxDeposit = () => {
    setDepositInput((userHedgeBalance / LAMPORTS_PER_SOL).toString())
  }

  const renderClosedPositions = () => {
    if (closedPoolPositions.length === 0) {
      return
    }

    return (
      <Row className="p-4">
        <Col>
          <div className="text-center mb-2">
            You have one or more closed positions that have not been claimed.
          </div>
          <Table variant="dark">
            <tr className="fw-bold">
              <th>Position</th>
              <th>State</th>
              <th></th>
            </tr>
            {closedPoolPositions.map((position, index) => {
              let text = 'Claim Rewards on'
              return (
                <tr key={index}>
                  <td className="small font-monospace">
                    {position.publicKey.toString().substring(0, 6)}...
                    {position.publicKey.toString().substring(38)}
                  </td>
                  <td className="">
                    {position.hasUnclaimedRewards() ? 'Unclaimed Tokens & Rent' : 'Unclaimed Rent'}
                  </td>
                  <td className="text-end">
                    <Button
                      variant="outline-light"
                      onClick={() => {
                        handleReclaim(position)
                      }}
                      size="sm"
                      disabled={processingTransaction}
                      className=""
                    >
                      Claim
                    </Button>
                  </td>
                </tr>
              )
            })}
          </Table>
        </Col>
      </Row>
    )
  }

  let poolApr = '(loading)'

  if(poolAprStakingPosition?.length > 0) {
    let poolRewards = poolAprStakingPosition[0].getUshAvailable().toNumber() / LAMPORTS_PER_SOL * ushPrice

    vaultTypes.forEach((vaultType) => {
      poolRewards += poolAprStakingPosition[0].getRewardsAtIndex(vaultType.collateralIndex).div(vaultType.lamportsPerCollateralUnit).toNumber() * recentPrices.get(vaultType.collateral) || 0
    })
    
    const timePassed = Math.floor(Date.now() / 1000) - poolAprStakingPosition[0].timestampOpened
    const rewardsPerYear = poolRewards / timePassed * 60 * 60 * 24 * 365

    const stakedValue = poolAprStakingPosition[0].deposited / LAMPORTS_PER_SOL * hdgPrice
    
    const apr = stakedValue > 0 ? rewardsPerYear / stakedValue : 0
    poolApr = numberWithCommas(apr * 100, 2)
  }

  const renderDeposit = () => {
    let depositDisabled = isNaN(parseFloat(depositInput)) || parseFloat(depositInput) <= 0
    let depositButtonText = !openPoolPositions ? 'Deposit' : 'Claim & Deposit'

    if (parseFloat(depositInput) > userHedgeBalance / LAMPORTS_PER_SOL) {
      depositDisabled = true
      depositButtonText = 'Not enough HDG'
    }

    if (!isNaN(parseFloat(depositInput)) && parseFloat(depositInput) < 0) {
      depositDisabled = true
      depositButtonText = 'No Negative'
    }

    if (processingTransaction) {
      depositDisabled = true
      depositButtonText = 'Processing...'
    }

    return (
      <div className="mt-1 d-flex align-items-center">
        <div className="flex-fill">
          <Form>
            <Form.Group className="">
              <InputGroup>
                <InputGroup.Text className="py-2">HDG</InputGroup.Text>
                <Form.Control
                  value={depositInput}
                  onChange={(ev) => setDepositInput(ev.target.value)}
                  className="py-2 px-3"
                  type="number"
                  placeholder="0"
                />
                <Button
                  className="py-2 px-3"
                  variant="light"
                  onClick={handleClickMaxDeposit}
                  disabled={processingTransaction}
                >
                  Max
                </Button>
              </InputGroup>
            </Form.Group>
          </Form>
        </div>
        <div className="ms-3">
          <Button variant="primary" onClick={handleDeposit} disabled={depositDisabled}>
            {depositButtonText}
          </Button>
        </div>
      </div>
    )
  }

  let deposits = '(loading)'
  if (poolState) {
    deposits = numberWithCommas(poolState.deposits / LAMPORTS_PER_SOL, 2)
  }

  let poolOwnership = '(loading)'
  if (poolState) {
    if (openPoolPositions.length > 0 && poolState.deposits > 0) {
      poolOwnership = ((openPoolPositions[0].deposited / poolState.deposits) * 100).toFixed(6) + '%'
    } else {
      poolOwnership = 'No position in pool'
    }
  }

  return (
    <>
      <Card className="mb-4">
        <Card.Body className="p-0">
          <div className="d-flex flex-column justify-content-between">
            <div>
              <Row className="p-4">
                <Col>
                  <div className="d-flex justify-content-between mb-3">
                    <div className="fw-bold h4">
                      <div>Staking Pool</div>

                      <div className="small text-primary d-flex align-items-center">
                        Collect a portion of protocol fees
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="text-muted">
                        Est. Pool APR{' '}
                        <InfoHover text={'APR is estimated by extrapolating revenue of 1 HDG token staked since July 12th 2022 divided by current HDG price.'} /> 
                      </div>                                    
                      <span className="mt-2">
                        <span className="text-number h3 fw-bold mb-0">
                          {poolApr}                      
                        </span>
                        <span className="ms-1 fw-light h5">%</span>
                      </span>                    
                    </div>
                  </div>
                  <div>
                    <i className="fa-thin fa-circle-1 me-2"></i>{' '}
                    <span className="text-muted">Deposit HDG</span>
                  </div>
                  <div>
                    <i className="fa-thin fa-circle-2 me-2"></i>{' '}
                    <span className="text-muted">Earn a share of protocol revenues</span>
                  </div>
                  <div>
                    <i className="fa-thin fa-circle-3 me-2"></i>{' '}
                    <span className="text-muted">Withdraw or claim at any time</span>
                  </div>
                </Col>
              </Row>

              <Row className="p-4 pt-0">
                <Col lg={{ span: 6, offset: 3 }}>
                  <div className="mt-1 mb-1 gradient-box p-4">
                    <div className="d-flex align-items-center text-muted">
                      <Image src={hdgCoin} width={28} height={28} alt="USH Coin" />{' '}
                      <span className="mx-2">Total Pool Holdings</span>{' '}
                      <InfoHover text="This is the total amount of HDG staked." />
                    </div>
                    <div>
                      {!poolState ? (
                        <div>Loading</div>
                      ) : (
                        <div className="mt-2 d-flex justify-content-start align-items-baseline">
                          <span className="text-number h3 fw-bold mb-0">{deposits}</span>
                          <span className="mx-2 fw-light">HDG</span>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {userWalletPublicKey ? (
                    isLoadingPositions ? (
                      <span>Loading</span>
                    ) : (
                      <>
                        <>{renderOpenPosition()}</>
                        <>{renderClosedPositions()}</>
                      </>
                    )
                  ) : (
                    <div className="p-4 mb-4 text-center">No Wallet Connected</div>
                  )}
                </Col>
              </Row>
            </div>
            <div>
              <Row className="p-4">
                <Col>
                  {userWalletPublicKey ? (
                    isLoadingPositions ? (
                      <span>Loading</span>
                    ) : (
                      <>{renderDeposit()}</>
                    )
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}

function mapStateToProps(state) {
  const { vaultTypes, userHedgeBalance, networkConnection } = state.wallet
  return {
    vaultTypes,
    userHedgeBalance,
    networkConnection,
  }
}
export default connect(mapStateToProps)(HedgeStakingPool)
